import { __awaiter, __generator } from "tslib";
import { createAsyncThunk } from '@reduxjs/toolkit';
export var asyncActionsFactory = function () {
    return function (name, action, options) {
        return createAsyncThunk(name, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(void 0, void 0, void 0, function () {
                var e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, action.apply(void 0, args)];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            e_1 = _a.sent();
                            console.error(e_1);
                            throw e_1;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }, options);
    };
};
//# sourceMappingURL=index.js.map